<!--欢迎界面-->
<template>
  <Layer
    :visible="visible"
    :layerName="layerName"
    id="welcome"
    style="z-index: 1001"
  >
    <div class="dlrLayer-bottom dlrWelcome">
      <div class="dlrWelcome-box">
        <div
          class="dlrWelcome-time"
          v-stat:click="{ action: 'arhall_welcomeskip_click' }"
          @click="close"
          id="J_jump"
        >
          <p>{{ time }}S</p>
          <p>跳过</p>
        </div>
        <div class="dlrWelcome-con img-placeholder">
          <img
            v-if="adData.imageUrl"
            :src="adData.imageUrl"
            id="welcome-pic"
            @click="openAd"
            class="dlrWelcome-pic"
          />
        </div>
        <div class="dlrWelcome-logo">
          <img :src="sharPanoImg" class="vm" />
          <span class="vm">汽车之家·智能展厅</span>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>
<script>
import { mapGetters } from 'vuex';
import util from '../utils/util';
import * as layerNames from '../services/layerName';
import layerManager from '../services/layer.manager';
import Layer from './Layer.vue';
export default {
  components: {
    Layer
  },
  props: {
    adData: {
      type: Object,
      default: function () {
        return {
          imageUrl: '',
          activityId: '',
          relType: 0,
          id: 0,
          name: ''
        };
      }
    }
  },
  data () {
    return {
      layerName: layerNames.WELCOME_AD,
      visible: true,
      time: 3,
      displayCls: 'fn-hide'
    };
  },
  computed: {
    ...mapGetters({
      baseInfo: 'baseInfo'
    }),
    dealerId () {
      return this.baseInfo.dealerId;
    },
    sharPanoImg () {
      return 'data:image/png;base64,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';
    }
  },
  created () {
    let self = this;
    self.countDown();
    util.setCookie({
      name: 'hideKaipingTwoHours',
      value: 'true',
      time: 2 * 60 * 60 * 1000
    });
  },
  methods: {
    openAd () {
      let self = this;
      let data = self.adData;
      if (data.relType === 1 && data.activityId) {
        self.close();
        layerManager.loadActivityInfo(data.activityId);
      } else if (data.relType === 2 && data.id) {
        self.close();
        layerManager.open(layerNames.VIDEO_PLAYER, { video: { name: data.name, videoId: data.id } });
      }
    },
    close () {
      this.visible = false;
    },
    countDown () {
      let self = this;
      self.timer = setInterval(() => {
        self.time = self.time - 1;
        if (self.time === 0) {
          self.close();
          window.clearInterval(self.timer);
          self.timer = null;
        }
      }, 1000);
    }
  }
};
</script>
<style lang="scss">
.dlrWelcome {
  width: 100%;
  height: 100%;
  background: #fff;
  &-box {
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
  }
  &-time {
    position: absolute;
    top: ptrd(44px);
    right: ptrd(34px);
    border-radius: 50%;
    width: ptrd(120px);
    height: ptrd(120px);
    font-size: ptrd(28);
    z-index: 2;
    background-color: rgba(153, 153, 153, 0.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    line-height: ptrd(44px);
    p {
      width: 100%;
    }
    p + p {
      position: relative;
      &::before {
        position: absolute;
        content: "";
        width: 70%;
        height: 1px;
        background: #fff;
        top: 0;
        left: 15%;
      }
    }
  }
  &-con {
    flex-shrink: 0;
    overflow: hidden;
  }
  &-pic {
    display: block;
    width: 100%;
  }
  &-logo {
    flex: 1;
    min-height: ptrd(170px);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #122579;
    font-size: ptrd(36px);
    background-color: #fff;
    img {
      width: ptrd(68px);
      height: ptrd(68px);
      margin-right: ptrd(16px);
    }
  }
}
</style>
